/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SetTransitByExerciseRequest } from '../entities';
// @ts-ignore
import type { SetTransitByExerciseResponse } from '../entities';
// @ts-ignore
import type { SetTransitRequest } from '../entities';
// @ts-ignore
import type { SetTransitResponse } from '../entities';
/**
 * SetTransitControllerApi - axios parameter creator
 * @export
 */
export const SetTransitControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {SetTransitRequest} setTransitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transit2: async (id: number, setTransitRequest: SetTransitRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('transit2', 'id', id)
            // verify required parameter 'setTransitRequest' is not null or undefined
            assertParamExists('transit2', 'setTransitRequest', setTransitRequest)
            const localVarPath = `/program/set/{id}/transit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTransitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitByExercise: async (setTransitByExerciseRequest: SetTransitByExerciseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setTransitByExerciseRequest' is not null or undefined
            assertParamExists('transitByExercise', 'setTransitByExerciseRequest', setTransitByExerciseRequest)
            const localVarPath = `/program/set/transit/exercise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTransitByExerciseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitBySession: async (setTransitByExerciseRequest: SetTransitByExerciseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setTransitByExerciseRequest' is not null or undefined
            assertParamExists('transitBySession', 'setTransitByExerciseRequest', setTransitByExerciseRequest)
            const localVarPath = `/program/set/transit/session`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTransitByExerciseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SetTransitControllerApi - functional programming interface
 * @export
 */
export const SetTransitControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SetTransitControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {SetTransitRequest} setTransitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transit2(id: number, setTransitRequest: SetTransitRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetTransitResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transit2(id, setTransitRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SetTransitControllerApi.transit2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transitByExercise(setTransitByExerciseRequest: SetTransitByExerciseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetTransitByExerciseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transitByExercise(setTransitByExerciseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SetTransitControllerApi.transitByExercise']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transitBySession(setTransitByExerciseRequest: SetTransitByExerciseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetTransitByExerciseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transitBySession(setTransitByExerciseRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SetTransitControllerApi.transitBySession']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SetTransitControllerApi - factory interface
 * @export
 */
export const SetTransitControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SetTransitControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {SetTransitRequest} setTransitRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transit2(id: number, setTransitRequest: SetTransitRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetTransitResponse> {
            return localVarFp.transit2(id, setTransitRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitByExercise(setTransitByExerciseRequest: SetTransitByExerciseRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetTransitByExerciseResponse> {
            return localVarFp.transitByExercise(setTransitByExerciseRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transitBySession(setTransitByExerciseRequest: SetTransitByExerciseRequest, options?: RawAxiosRequestConfig): AxiosPromise<SetTransitByExerciseResponse> {
            return localVarFp.transitBySession(setTransitByExerciseRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SetTransitControllerApi - object-oriented interface
 * @export
 * @class SetTransitControllerApi
 * @extends {BaseAPI}
 */
export class SetTransitControllerApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {SetTransitRequest} setTransitRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetTransitControllerApi
     */
    public transit2(id: number, setTransitRequest: SetTransitRequest, options?: RawAxiosRequestConfig) {
        return SetTransitControllerApiFp(this.configuration).transit2(id, setTransitRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetTransitControllerApi
     */
    public transitByExercise(setTransitByExerciseRequest: SetTransitByExerciseRequest, options?: RawAxiosRequestConfig) {
        return SetTransitControllerApiFp(this.configuration).transitByExercise(setTransitByExerciseRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetTransitByExerciseRequest} setTransitByExerciseRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SetTransitControllerApi
     */
    public transitBySession(setTransitByExerciseRequest: SetTransitByExerciseRequest, options?: RawAxiosRequestConfig) {
        return SetTransitControllerApiFp(this.configuration).transitBySession(setTransitByExerciseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

